import { memo, useState, useCallback } from 'react';
import { useSignal } from '@artica/hooks';

export default memo(function RenderCheck() {
  const [hasCalled, setHasCalled] = useState(false);
  const signal = useSignal();
  const onCreated = useCallback(() => {
    setHasCalled(true);
    signal.emit('scene:ready');
  }, [signal]);

  if (hasCalled) return null;

  return (
    <mesh onAfterRender={ onCreated } />
  );
});